export const REGISTRATION_STEPS_URLS = [
  '/register/account-setup',
  '/register/entity-information',
  '/register/bank-information',
  '/register/verification',
];

export const WATHEQ_SESSION_KEY = 'WATHEQ_SESSION';
export const WATHEQ_RESPONSE_KEY = 'WATHEQ_RESPONSE';
export const WATHEQ_ERROR_KEY = 'WATHEQ_ERROR';
export const WATHEQ_ERROR_BLOCKED = 'blocked';
export const WATHEQ_ERROR_CRM_INVALID = 'invalid';

export const TOO_MANY_REQUEST_KEY = 'to_many_request';
export const VERIFY_SMS_SUCCESS_KEY = 'success_message';

export const CRM_ERROR_WATHEQ_CODE = '400';
export const CRM_ERROR_WATHEQ = 'CRM is already in use.';

export const ABSHER_OTP_BLOCKED_ERROR_KEY = 'ABSHER_BLOCKED';

export type COMPANY_STATUS =
  | 'verified'
  | 'pending'
  | 'screened'
  | 'rejected'
  | 'draft';

export const PHONE_NUMBER_REGEX = /^5\d{8}$/;
export const ONLY_DIGIT_REGEX = /^\d+$/;
export const UNIFIED_NATIONAL_NUMBER_REGEX = /^7\d{9}$/;
export const VAT_NUMBER_REGEX = /^3\d{14}$/;

export enum DOCUMENT_TYPE {
  COMPANY = 'company',
  FOREIGN_COMPANY = 'foreign_company',
  ESTABLISHMENT = 'establishment',
  INVESTMENT = 'investment_fund',
  GOVERNMENT = 'governmental_fund',
  NON_PROFIT = 'non_profit',
}

/** Some APIs return the Arabic legal form instead of the canonical enum value. */
export function normalizeCompanyType(
  companyType: string | null | undefined,
): string {
  if (companyType == null || companyType === '') return '';
  if (companyType === 'شركة') return DOCUMENT_TYPE.COMPANY;
  return companyType;
}

export const ACCOUNT_SETUP_COOKIE_KEY = 'sACS';

export const TRANSFER_FORM_NAME = 'investor_withdrawal';

export const DATE_FORMATS = {
  KSA_DATE: 'YYYY/MM/DD',
  DAY_MONTH_SHORT: 'DD MMM',
} as const;
export const BUSINESS_TYPES = {
  company: 'company',
  foreign_company: 'partialOrFullForeign',
  investment_fund: 'investment',
  governmental_fund: 'government',
  non_profit: 'nonProfit',
  establishment: 'establishment',
};

export const bankListing = [
  {
    id: 1,
    clearing_code: '10',
    swift_code: 'NCBKSAJE',
    name_en: 'Saudi National Bank',
    name_ar: 'البنك الأهلي السعودي',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/national-commercial-bank-logo.jpg',
  },
  {
    id: 2,
    clearing_code: '45',
    swift_code: 'SABBSARI',
    name_en: 'SABB Bank',
    name_ar: 'بنك ساب',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/sabb-logo.jpg',
  },
  {
    id: 3,
    clearing_code: '80',
    swift_code: 'RJHISARI',
    name_en: 'Al Rajhi Bank',
    name_ar: 'مصرف الراجحي',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/al-rajhi-capital-bank.jpg',
  },
  {
    id: 4,
    clearing_code: '00',
    swift_code: 'AAALSARI',
    name_en: 'Alawwal Bank',
    name_ar: 'البنك الأول',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/alawwal-bank-logo.jpg',
  },
  {
    id: 5,
    clearing_code: '30',
    swift_code: 'ARNBSARI',
    name_en: 'Arab National Bank',
    name_ar: 'البنك العربي الوطني',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/arab-national-bank.jpg',
  },
  {
    id: 6,
    clearing_code: '60',
    swift_code: 'BJAZSAJE',
    name_en: 'Bank AlJazira',
    name_ar: 'بنك الجزيرة',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/bank-aljazira-logo.jpg',
  },
  {
    id: 7,
    clearing_code: '55',
    swift_code: 'BSFRSARI',
    name_en: 'Banque Saudi Fransi',
    name_ar: 'البنك السعودي الفرنسي',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/bank-saudi-fransi-logo.jpg',
  },
  {
    id: 8,
    clearing_code: '20',
    swift_code: 'RIBLSARI',
    name_en: 'Riyad Bank',
    name_ar: 'بنك الرياض',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/riyad-bank-logo.jpg',
  },
  {
    id: 9,
    clearing_code: '65',
    swift_code: 'SIBCSARI',
    name_en: 'The Saudi Investment Bank',
    name_ar: 'البنك السعودي للاستثمار',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/saudi-investment-bank-logo.jpg',
  },
  {
    id: 10,
    clearing_code: '15',
    swift_code: 'ALBISARI',
    name_en: 'Bank Al Bilad',
    name_ar: 'بنك البلاد',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/bank-albilad-logo.jpg',
  },
  {
    id: 11,
    clearing_code: '76',
    swift_code: 'BMUSSARI',
    name_en: 'Muscat Bank',
    name_ar: 'بنك مسقط',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/bank-muscat-logo.jpg',
  },
  {
    id: 12,
    clearing_code: '05',
    swift_code: 'INMASARI',
    name_en: 'Alinma Bank',
    name_ar: 'مصرف الانماء',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/alinma-bank-log.jpg',
  },
  {
    id: 13,
    clearing_code: '95',
    swift_code: 'EBILSARI',
    name_en: 'Emirates NBD Bank',
    name_ar: 'بنك الامارات دبي الوطني',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/emirates-nbd-bank.jpg',
  },
  {
    id: 14,
    clearing_code: '90',
    swift_code: 'GULFSARI',
    name_en: 'Gulf International Bank',
    name_ar: 'بنك الخليج الدولي',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/gulf-international-bank-logo.jpg',
  },
  {
    id: 15,
    clearing_code: '78',
    swift_code: 'STCJSARI',
    name_en: 'STC Bank',
    name_ar: 'بنك اس تي سي',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/stc-bank-logo.jpg',
  },
  {
    id: 16,
    clearing_code: '36',
    swift_code: 'DBAKSARI',
    name_en: 'D360 Bank',
    name_ar: 'دال ثلاثمائة وستون',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/d360-bank-logo.jpg',
  },
  {
    id: 17,
    clearing_code: '93',
    swift_code: 'VIIOSARI',
    name_en: 'Vision Bank',
    name_ar: 'بنك فيجن',
    logo: 'https://abyancapital.s3.eu-west-1.amazonaws.com/abyan/resources/images/bank-logos/viiosari-bank-logo.jpg',
  },
];

export const businessTypeOptions = [
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.company',
    value: 'company',
  },
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.investment',
    value: 'investment_fund',
  },
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.government',
    value: 'governmental_fund',
  },
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.nonProfit',
    value: 'non_profit',
  },
  {
    label:
      'Onboarding.Protected.BusinessDetails.buisnessTypes.partialOrFullForeign',
    value: 'governmental_entity',
  },
  {
    label:
      'Onboarding.Protected.BusinessDetails.buisnessTypes.internationalHeadquarter',
    value: 'international_organization',
  },
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.waqf',
    value: 'waqf',
  },
  {
    label: 'Onboarding.Protected.BusinessDetails.buisnessTypes.establishment',
    value: 'other',
  },
];

export const accountPurposeOptions = [
  {
    value: 'specific_company_investments',
    label: 'Onboarding.Protected.InvestmentInfo.specificToCompanyInvestment',
  },
  {
    value: 'specific_clients_investments',
    label:
      'Onboarding.Protected.InvestmentInfo.specificToCompanyClientInvestment',
  },
];

export const investmentObjectivesOptions = [
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.capitalPreservation',
    value: 'capital_preservation',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.incomeGeneration',
    value: 'income_generation',
  },
  {
    label: 'Onboarding.Protected.InvestmentInfo.investmentObjectives.balanced',
    value: 'balanced',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.capitalGrowth',
    value: 'capital_growth',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.retirementSavings',
    value: 'retirement_savings',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.projectFinancing',
    value: 'project_financing',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.investmentObjectives.assetPurchase',
    value: 'purchase_of_an_asset',
  },
];

export const timeFrameToRecoverInvestment = [
  {
    label:
      'Onboarding.Protected.InvestmentInfo.timeFrameToRecoverInvestmentFunc.shortTerm',
    value: 'short_term',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.timeFrameToRecoverInvestmentFunc.mediumTerm',
    value: 'medium_term',
  },
  {
    label:
      'Onboarding.Protected.InvestmentInfo.timeFrameToRecoverInvestmentFunc.longTerm',
    value: 'long_term',
  },
];

export const CURRENCY_MAP: Record<string, { en: string; ar: string }> = {
  AED: { en: 'United Arab Emirates Dirham', ar: 'درهم إماراتي' },
  AFN: { en: 'Afghan Afghani', ar: 'أفغاني' },
  ALL: { en: 'Albanian Lek', ar: 'ليك ألباني' },
  AMD: { en: 'Armenian Dram', ar: 'درام أرميني' },
  ANG: { en: 'Netherlands Antillean Guilder', ar: 'غيلدر جزر الأنتيل' },
  AOA: { en: 'Angolan Kwanza', ar: 'كوانزا أنغولي' },
  ARS: { en: 'Argentine Peso', ar: 'بيزو أرجنتيني' },
  AUD: { en: 'Australian Dollar', ar: 'دولار أسترالي' },
  AWG: { en: 'Aruban Florin', ar: 'فلورن أروبي' },
  AZN: { en: 'Azerbaijani Manat', ar: 'مانات أذربيجاني' },
  BAM: {
    en: 'Bosnia-Herzegovina Convertible Mark',
    ar: 'مارك قابل للتحويل بوسني',
  },
  BBD: { en: 'Barbadian Dollar', ar: 'دولار بربادوسي' },
  BDT: { en: 'Bangladeshi Taka', ar: 'تاكا بنغلاديشي' },
  BGN: { en: 'Bulgarian Lev', ar: 'ليف بلغاري' },
  BHD: { en: 'Bahraini Dinar', ar: 'دينار بحريني' },
  BIF: { en: 'Burundian Franc', ar: 'فرنك بوروندي' },
  BMD: { en: 'Bermudian Dollar', ar: 'دولار برمودي' },
  BND: { en: 'Brunei Dollar', ar: 'دولار بروناي' },
  BOB: { en: 'Bolivian Boliviano', ar: 'بوليفيانو بوليفي' },
  BRL: { en: 'Brazilian Real', ar: 'ريال برازيلي' },
  BSD: { en: 'Bahamian Dollar', ar: 'دولار بهامي' },
  BTN: { en: 'Bhutanese Ngultrum', ar: 'نغولتروم بوتاني' },
  BWP: { en: 'Botswanan Pula', ar: 'بولا بوتسواني' },
  BYN: { en: 'Belarusian Ruble', ar: 'روبل بيلاروسي' },
  BZD: { en: 'Belize Dollar', ar: 'دولار بيليزي' },
  CAD: { en: 'Canadian Dollar', ar: 'دولار كندي' },
  CDF: { en: 'Congolese Franc', ar: 'فرنك كونغولي' },
  CHF: { en: 'Swiss Franc', ar: 'فرنك سويسري' },
  CLP: { en: 'Chilean Peso', ar: 'بيزو تشيلي' },
  CNY: { en: 'Chinese Yuan', ar: 'يوان صيني' },
  COP: { en: 'Colombian Peso', ar: 'بيزو كولومبي' },
  CRC: { en: 'Costa Rican Colón', ar: 'كولون كوستاريكي' },
  CUP: { en: 'Cuban Peso', ar: 'بيزو كوبي' },
  CVE: { en: 'Cape Verdean Escudo', ar: 'إسكودو الرأس الأخضر' },
  CZK: { en: 'Czech Koruna', ar: 'كورونا تشيكية' },
  DJF: { en: 'Djiboutian Franc', ar: 'فرنك جيبوتي' },
  DKK: { en: 'Danish Krone', ar: 'كرونة دنماركية' },
  DOP: { en: 'Dominican Peso', ar: 'بيزو دومينيكي' },
  DZD: { en: 'Algerian Dinar', ar: 'دينار جزائري' },
  EGP: { en: 'Egyptian Pound', ar: 'جنيه مصري' },
  ERN: { en: 'Eritrean Nakfa', ar: 'ناكفا إريترية' },
  ETB: { en: 'Ethiopian Birr', ar: 'بير إثيوبي' },
  EUR: { en: 'Euro', ar: 'يورو' },
  FJD: { en: 'Fijian Dollar', ar: 'دولار فيجي' },
  FKP: { en: 'Falkland Islands Pound', ar: 'جنيه جزر فوكلاند' },
  FOK: { en: 'Faroese Króna', ar: 'كرونا فاروسية' },
  GBP: { en: 'British Pound Sterling', ar: 'جنيه إسترليني' },
  GEL: { en: 'Georgian Lari', ar: 'لاري جورجي' },
  GGP: { en: 'Guernsey Pound', ar: 'جنيه غيرنزي' },
  GHS: { en: 'Ghanaian Cedi', ar: 'سيدي غاني' },
  GIP: { en: 'Gibraltar Pound', ar: 'جنيه جبل طارق' },
  GMD: { en: 'Gambian Dalasi', ar: 'دالاسي غامبي' },
  GNF: { en: 'Guinean Franc', ar: 'فرنك غيني' },
  GTQ: { en: 'Guatemalan Quetzal', ar: 'كيتزال غواتيمالي' },
  GYD: { en: 'Guyanaese Dollar', ar: 'دولار غياني' },
  HKD: { en: 'Hong Kong Dollar', ar: 'دولار هونغ كونغ' },
  HNL: { en: 'Honduran Lempira', ar: 'ليمبيرا هندوراسية' },
  HRK: { en: 'Croatian Kuna', ar: 'كونا كرواتية' },
  HTG: { en: 'Haitian Gourde', ar: 'جورد هايتي' },
  HUF: { en: 'Hungarian Forint', ar: 'فورنت مجري' },
  IDR: { en: 'Indonesian Rupiah', ar: 'روبية إندونيسية' },
  ILS: { en: 'Israeli New Shekel', ar: 'شيكل إسرائيلي جديد' },
  IMP: { en: 'Isle of Man Pound', ar: 'جنيه جزيرة مان' },
  INR: { en: 'Indian Rupee', ar: 'روبية هندية' },
  IQD: { en: 'Iraqi Dinar', ar: 'دينار عراقي' },
  IRR: { en: 'Iranian Rial', ar: 'ريال إيراني' },
  ISK: { en: 'Icelandic Króna', ar: 'كرونا أيسلندية' },
  JEP: { en: 'Jersey Pound', ar: 'جنيه جيرزي' },
  JMD: { en: 'Jamaican Dollar', ar: 'دولار جامايكي' },
  JOD: { en: 'Jordanian Dinar', ar: 'دينار أردني' },
  JPY: { en: 'Japanese Yen', ar: 'ين ياباني' },
  KES: { en: 'Kenyan Shilling', ar: 'شلن كيني' },
  KGS: { en: 'Kyrgystani Som', ar: 'سوم قيرغيزي' },
  KHR: { en: 'Cambodian Riel', ar: 'ريال كمبودي' },
  KID: { en: 'Kiribati Dollar', ar: 'دولار كيريباتي' },
  KMF: { en: 'Comorian Franc', ar: 'فرنك جزر القمر' },
  KRW: { en: 'South Korean Won', ar: 'وون كوري جنوبي' },
  KWD: { en: 'Kuwaiti Dinar', ar: 'دينار كويتي' },
  KYD: { en: 'Cayman Islands Dollar', ar: 'دولار جزر كايمان' },
  KZT: { en: 'Kazakhstani Tenge', ar: 'تينغي كازاخستاني' },
  LAK: { en: 'Laotian Kip', ar: 'كيب لاوسي' },
  LBP: { en: 'Lebanese Pound', ar: 'ليرة لبنانية' },
  LKR: { en: 'Sri Lankan Rupee', ar: 'روبية سريلانكية' },
  LRD: { en: 'Liberian Dollar', ar: 'دولار ليبيري' },
  LSL: { en: 'Lesotho Loti', ar: 'لوتي ليسوتي' },
  LYD: { en: 'Libyan Dinar', ar: 'دينار ليبي' },
  MAD: { en: 'Moroccan Dirham', ar: 'درهم مغربي' },
  MDL: { en: 'Moldovan Leu', ar: 'ليو مولدوفي' },
  MGA: { en: 'Malagasy Ariary', ar: 'أرياري ملغاشي' },
  MKD: { en: 'Macedonian Denar', ar: 'دينار مقدوني' },
  MMK: { en: 'Myanmar Kyat', ar: 'كيات ميانماري' },
  MNT: { en: 'Mongolian Tugrik', ar: 'توغروغ مغولي' },
  MOP: { en: 'Macanese Pataca', ar: 'باتاكا ماكاوي' },
  MRU: { en: 'Mauritanian Ouguiya', ar: 'أوقية موريتانية' },
  MUR: { en: 'Mauritian Rupee', ar: 'روبية موريشيوسية' },
  MVR: { en: 'Maldivian Rufiyaa', ar: 'روفيا مالديفية' },
  MWK: { en: 'Malawian Kwacha', ar: 'كواتشا مالاوي' },
  MXN: { en: 'Mexican Peso', ar: 'بيزو مكسيكي' },
  MYR: { en: 'Malaysian Ringgit', ar: 'رينغيت ماليزي' },
  MZN: { en: 'Mozambican Metical', ar: 'ميتيكال موزمبيقي' },
  NAD: { en: 'Namibian Dollar', ar: 'دولار ناميبي' },
  NGN: { en: 'Nigerian Naira', ar: 'نايرا نيجيرية' },
  NIO: { en: 'Nicaraguan Córdoba', ar: 'كوردوبا نيكاراغوي' },
  NOK: { en: 'Norwegian Krone', ar: 'كرونة نرويجية' },
  NPR: { en: 'Nepalese Rupee', ar: 'روبية نيبالية' },
  NZD: { en: 'New Zealand Dollar', ar: 'دولار نيوزيلندي' },
  OMR: { en: 'Omani Rial', ar: 'ريال عماني' },
  PAB: { en: 'Panamanian Balboa', ar: 'بالبوا بنمي' },
  PEN: { en: 'Peruvian Sol', ar: 'سول بيروفي' },
  PGK: { en: 'Papua New Guinean Kina', ar: 'كينا بابوا غينيا الجديدة' },
  PHP: { en: 'Philippine Peso', ar: 'بيزو فلبيني' },
  PKR: { en: 'Pakistani Rupee', ar: 'روبية باكستانية' },
  PLN: { en: 'Polish Zloty', ar: 'زلوتي بولندي' },
  PYG: { en: 'Paraguayan Guarani', ar: 'غواراني باراغواي' },
  QAR: { en: 'Qatari Rial', ar: 'ريال قطري' },
  RON: { en: 'Romanian Leu', ar: 'ليو روماني' },
  RSD: { en: 'Serbian Dinar', ar: 'دينار صربي' },
  RUB: { en: 'Russian Ruble', ar: 'روبل روسي' },
  RWF: { en: 'Rwandan Franc', ar: 'فرنك رواندي' },
  SAR: { en: 'Saudi Riyal', ar: 'ريال سعودي' },
  SBD: { en: 'Solomon Islands Dollar', ar: 'دولار جزر سليمان' },
  SCR: { en: 'Seychellois Rupee', ar: 'روبية سيشيلية' },
  SDG: { en: 'Sudanese Pound', ar: 'جنيه سوداني' },
  SEK: { en: 'Swedish Krona', ar: 'كرونة سويدية' },
  SGD: { en: 'Singapore Dollar', ar: 'دولار سنغافوري' },
  SHP: { en: 'Saint Helena Pound', ar: 'جنيه سانت هيلينا' },
  SLL: { en: 'Sierra Leonean Leone', ar: 'ليون سيراليوني' },
  SOS: { en: 'Somali Shilling', ar: 'شلن صومالي' },
  SRD: { en: 'Surinamese Dollar', ar: 'دولار سورينامي' },
  SSP: { en: 'South Sudanese Pound', ar: 'جنيه جنوب سوداني' },
  STN: { en: 'São Tomé and Príncipe Dobra', ar: 'دوبرا ساو تومي وبرينسيبي' },
  SYP: { en: 'Syrian Pound', ar: 'ليرة سورية' },
  SZL: { en: 'Swazi Lilangeni', ar: 'ليلانجيني سوازيلندي' },
  THB: { en: 'Thai Baht', ar: 'بات تايلاندي' },
  TJS: { en: 'Tajikistani Somoni', ar: 'سوموني طاجيكي' },
  TMT: { en: 'Turkmenistani Manat', ar: 'مانات تركماني' },
  TND: { en: 'Tunisian Dinar', ar: 'دينار تونسي' },
  TOP: { en: 'Tongan Paʻanga', ar: 'بانغا تونغي' },
  TRY: { en: 'Turkish Lira', ar: 'ليرة تركية' },
  TTD: { en: 'Trinidad and Tobago Dollar', ar: 'دولار ترينيداد وتوباغو' },
  TVD: { en: 'Tuvaluan Dollar', ar: 'دولار توفالي' },
  TWD: { en: 'New Taiwan Dollar', ar: 'دولار تايواني جديد' },
  TZS: { en: 'Tanzanian Shilling', ar: 'شلن تنزاني' },
  UAH: { en: 'Ukrainian Hryvnia', ar: 'هريفنيا أوكرانية' },
  UGX: { en: 'Ugandan Shilling', ar: 'شلن أوغندي' },
  USD: { en: 'United States Dollar', ar: 'دولار أمريكي' },
  UYU: { en: 'Uruguayan Peso', ar: 'بيزو أوروغواي' },
  UZS: { en: 'Uzbekistan Som', ar: 'سوم أوزبكي' },
  VES: { en: 'Venezuelan Bolívar', ar: 'بوليفار فنزويلي' },
  VND: { en: 'Vietnamese Dong', ar: 'دونغ فيتنامي' },
  VUV: { en: 'Vanuatu Vatu', ar: 'فاتو فانواتي' },
  WST: { en: 'Samoan Tala', ar: 'تالا ساموي' },
  XAF: { en: 'Central African CFA Franc', ar: 'فرنك وسط أفريقي' },
  XCD: { en: 'East Caribbean Dollar', ar: 'دولار شرق كاريبي' },
  XOF: { en: 'West African CFA Franc', ar: 'فرنك غرب أفريقي' },
  XPF: { en: 'CFP Franc', ar: 'فرنك سي إف بي' },
  YER: { en: 'Yemeni Rial', ar: 'ريال يمني' },
  ZAR: { en: 'South African Rand', ar: 'راند جنوب أفريقي' },
  ZMW: { en: 'Zambian Kwacha', ar: 'كواتشا زامبي' },
  ZWL: { en: 'Zimbabwean Dollar', ar: 'دولار زيمبابوي' },
};

export const productsInvestedInOptions = [
  {
    label: 'Onboarding.Protected.InvestmentInfo.depositMurabaha',
    value: 'deposits_and_murabaha',
  },
  {
    label: 'Onboarding.Protected.InvestmentInfo.debtInstruments',
    value: 'debt_instruments',
  },
  { label: 'Onboarding.Protected.InvestmentInfo.equities', value: 'equities' },
  {
    label: 'Onboarding.Protected.InvestmentInfo.realEstate',
    value: 'real_estate',
  },
  {
    label: 'Onboarding.Protected.InvestmentInfo.derivatives',
    value: 'derivatives_contracts',
  },
  {
    label: 'Onboarding.Protected.InvestmentInfo.alternativeInvestment',
    value: 'alternative_investments',
  },
  {
    label: 'Onboarding.Protected.InvestmentInfo.investmentFunds',
    value: 'investment_funds',
  },
];

export const riskLevelOptions = [
  { label: 'Onboarding.Protected.InvestmentInfo.low', value: 'low' },
  { label: 'Onboarding.Protected.InvestmentInfo.medium', value: 'medium' },
  { label: 'Onboarding.Protected.InvestmentInfo.high', value: 'high' },
];

const KYB_STEPS = [
  'business_details',
  'documents',
  'national_address',
  'authorization',
  'investment_info',
  'bank_account',
  'summary',
] as const;

export type KybStep = (typeof KYB_STEPS)[number];

export function canAccessStep(currentStatus: KybStep, targetStep: KybStep) {
  const currentIndex = KYB_STEPS.indexOf(currentStatus);
  const targetIndex = KYB_STEPS.indexOf(targetStep);

  if (currentIndex === -1 || targetIndex === -1) return false;

  return targetIndex <= currentIndex;
}
